// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ub-2";
export var chatLink = "_ub-0";
export var chatText = "_ub-1";